import { FC, useEffect, useMemo, useState, useCallback } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { MdAdd } from 'react-icons/md';
import { ImCross } from 'react-icons/im';
import Screen from '../../components/layout/Screen';
import {ADMIN_ACCOUNTS} from '../../config/accounts'
import { useViewport } from '../../hooks/useViewport';
//get-nfts
import { useWalletNfts } from '@nfteyez/sol-rayz-react';
//modal
import Modal from '@material-ui/core/Modal';
//input
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import moment, { Moment } from 'moment';
//create-raffle
import { TOKEN_PROGRAM_ID } from '@solana/spl-token';
import { createRaffle } from '../../lib/actions/createRaffle';
import { useProgramApis } from '../../hooks/useProgramApis';
import { PublicKey } from '@solana/web3.js';
import { txHandler } from '../../lib/anchorUtils';
//wallet
import { useConnection } from '@solana/wallet-adapter-react';
import { useWallet } from '@solana/wallet-adapter-react';
import { Wallet, web3 } from '@project-serum/anchor';
//analytics
import { Mixpanel } from '../../lib/Mixpanel';
//alert
import toast from 'react-hot-toast';
//tokens
import { tokenInfoMap } from '../../config/tokenRegistry';
//project whitelist
import projectRegistry from '../../config/projectRegistry';
function CreateRaffle() {
  const { draffleClient } = useProgramApis();
  const { connection } = useConnection();
  const { publicKey } = useWallet();
  const { device } = useViewport();
  const [tagHolder, setTagHolder] = useState('');
  const classes = useStyles({ device });
  const [finalNFTs, setFinalNFTs] = useState<any[]>([]);
  const { nfts, isLoading, error } = useWalletNfts({
    //@ts-ignore
    publicAddress: publicKey?.toBase58(),
    // pass your connection object to use specific RPC node
    connection,
  });
  const [raffleNFT, setRaffleNFT] = useState<any | null>(null);
  const [token, setToken] = useState('');
  const [endTimestamp, setEndTimestamp] = useState<string>('');
  // console.log(moment().add(1, 'hours').format('DD-MM-YYYY HH:MM'), 'date');
  const [ticketSupply, setTicketSupply] = useState('');
  const [ticketPrice, setTicketPrice] = useState('');

  const [nftMint, setNftMint] = useState('');

  // console.log(nfts, 'all nfts');
  // console.log(tokenInfoMap, 'tim');

  const handleChange = (event: any) => {
    setToken(event.target.value as string);
  };

  useEffect(() => {
    update_nfts();
  }, [nfts]);

  async function update_nfts() {
    let tempArr: any[] = [];
    // setNftMint(nfts[0].)
    if (nfts && nfts.length) {
      nfts.map(async (item: any, i: any) => {
        // console.log(item, 'item');
        await fetch(item.data.uri)
          .then(async (data: any) => {
            nfts[i].data.metadata = await data.json();
            // console.log(projectRegistry.includes(nfts[i].updateAuthority), 'pr');
            if (
              // nfts[i].data.symbol ===
              //   (process.env?.REACT_APP_RPC_ENDPOINT &&
              //   process.env?.REACT_APP_RPC_ENDPOINT.includes('devnet')
              //     ? 'CAS'
              //     : 'TAG') &&
              // nfts[i].updateAuthority ===
              //   (process.env?.REACT_APP_RPC_ENDPOINT &&
              //   process.env?.REACT_APP_RPC_ENDPOINT.includes('devnet')
              //     ? '5gtU6iXuapZzRDrWY16hYEvgSfNPBn1Doos6RcnAbzRA'
              //     : '8FkMivDfqqFLH3eRBnJ8krkbQemUfDthLcTXjwSqkQee')
              projectRegistry.includes(nfts[i].data.creators[0].address) &&
              nfts[i].data.creators[0].verified
            ) {
              // console.log(nfts[i], ' discount because of this nft');

              // console.log(nfts[i], 'data');

              setNftMint(nfts[i].mint);
              //@ts-ignore
              setTagHolder(nfts[i].data.name);
            }
            tempArr.push(nfts[i]);
            //  console.log(await data.json(), 'data');
          })
          .catch((err) => {
            //console.log(err, 'err fetching nft detail')
          });
      });
      setFinalNFTs(tempArr);
    }
  }

  //modal
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // console.log({
  //   //@ts-ignore
  //   endTimestamp: endTimestamp,
  //   ticketSupply,
  //   ticketPrice,
  //   token,
  // });

  // console.log(nfts, 'nfts');

  // Execture function, submit form, clear data

  const getTimestamp = (timestamp: Moment) => {
    if (moment.duration(timestamp.diff(moment())).asHours() < 0) {
      console.log(
        moment.duration(timestamp.diff(moment())).asHours(),
        'duration in s'
      );
      toast.error('End Date should be at least 24 Hour long');
      return 0;
    }
    return timestamp.unix();
  };
  // console.log(moment.duration(endTimestamp.diff(moment())).asSeconds(), 'cmp');

  const handleRaffle = async (e: any) => {
    const SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID: PublicKey = new PublicKey(
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'
    );
    e.preventDefault();

    let adjustedEndTimestamp = getTimestamp(moment(endTimestamp));

    if (
      token &&
      raffleNFT &&
      ticketSupply &&
      publicKey &&
      adjustedEndTimestamp > 0
    ) {
      let tokenMint = '';
      const finalToken = Array.from(tokenInfoMap.values()).filter(
        (t) => t.symbol === token
      )[0];
      // console.log(finalToken, 'ft')
      tokenMint = finalToken.address;
      
    let adjustedTicketCost = Number(ticketPrice) * Math.pow(10, (finalToken.decimals||9));
      const associatedTokenAcc = (
        await PublicKey.findProgramAddress(
          [
            publicKey.toBuffer(),
            TOKEN_PROGRAM_ID.toBuffer(),
            new web3.PublicKey(nftMint || raffleNFT.mint).toBuffer(),
          ],
          SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID
        )
      )[0];
      const [metadata_account_pda, _] = await PublicKey.findProgramAddress(
        [
          Buffer.from('metadata'),
          new PublicKey(
            'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s'
          ).toBytes(),
          new PublicKey(nftMint || raffleNFT.mint).toBytes(),
        ],
        new PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')
      );
      if (adjustedEndTimestamp && metadata_account_pda) {
        const status = await txHandler(
          () =>
            createRaffle(
              draffleClient,
              draffleClient.provider.wallet.publicKey,
              new PublicKey(tokenMint),
              adjustedEndTimestamp,
              adjustedTicketCost,
              Number(ticketSupply),
              new PublicKey(raffleNFT.mint),
              0,
              1,
              nftMint || raffleNFT.mint,
              associatedTokenAcc,
              metadata_account_pda
            ),
          `Raffle created successfully!`
        );
        // console.log(status, 'status of creating raffle');
        if (status) {
            Mixpanel.identify(
              draffleClient.provider.wallet.publicKey.toBase58()
            );
            Mixpanel.track('Create Raffle', {
              raffleID: status,
              source: 'MOM Raffle Website',
              endTimestamp: endTimestamp.valueOf(),
              token: token,
              creator:
                publicKey?.toBase58() ||
                draffleClient.provider.wallet.publicKey.toBase58(),
              nft: raffleNFT,
              featured: tagHolder ? true : false,
              proceeds_collected: false,
              claimed_prizes: false,
              ticketPrice,
              ticketSupply,
            });
            setEndTimestamp('');
            setToken('');
            setTicketSupply('');
            setTicketPrice('');
            setRaffleNFT(null);
        }
      }
    } else {
      if (!adjustedEndTimestamp) {
      } else {
        toast.error('Some Fields Are Missing!');
      }
    }
  };
  // program to check if a number is a float or integer value

  function checkNumber(x: any) {
    // check if the passed value is a number

    let regexPattern = /^-?[0-9]+$/;

    // check if the passed number is integer or float
    let result = regexPattern.test(x);
    // console.log(result, 'result')

    if (result) {
      // console.log(`${x} is an integer.`);
      return true;
    } else if (isNaN(x)) {
      // console.log(`${x} is not a valid Number.`);
      return false;
    } else {
      return true;
    }
  }
  return (
    <Screen>
      <div className="w-full relative z-20">
        <div>
          <h1 className={'GTWalsheimProBold text-center pb-6 text-white'}>
            Create Your Own Raffle
          </h1>
        </div>
        {publicKey && ADMIN_ACCOUNTS && ADMIN_ACCOUNTS.includes(publicKey.toBase58()) ? (
         
          <div className="flex flex-wrap justify-center items-start w-full mb-4">
            <div className="w-full md:w-4/12 flex mb-6 justify-center items-center">
              {raffleNFT && raffleNFT.data ? (
                <div
                  onClick={handleOpen}
                  className="overflow-hidden text-brand_secondary flex justify-center items-center bg-gray-900 bg-opacity-20 hover:bg-brand_primary hover:bg-opacity-100 cursor-pointer"
                  style={{ width: '80%', minHeight: '20vh' }}
                >
                  <div>
                    <img
                      src={raffleNFT.data.metadata.image}
                      alt={raffleNFT.data.metadata.name}
                    />
                    <p className="GTWalsheimProBold p-2 bg-brand_smooth_gray text-white text-center">
                      {raffleNFT.data.metadata.name}
                    </p>
                  </div>
                </div>
              ) : (
                <div
                  onClick={handleOpen}
                  className="border-brand_secondary border bg-brand_smooth_gray text-brand_secondary flex justify-center items-center hover:bg-white hover:text-brand_primary cursor-pointer"
                  style={{ width: '80%', minHeight: '300px' }}
                >
                  <div className="flex flex-col justify-center items-center">
                    <MdAdd className="text-5xl" />
                    <h3 className="GTWalsheimProBold 2xl:text-xl py-2 primary_font uppercase">
                      Choose NFT for Raffle
                    </h3>
                  </div>
                </div>
              )}
            </div>
            <div className="w-full md:w-8/12 bg-brand_smooth_gray p-6">
              <div className="text-white mb-2 date-picker bg-white">
                <TextField
                  variant="filled"
                  id="datetime-local"
                  label="Raffle End Date"
                  type="datetime-local"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={endTimestamp}
                  onChange={(e) => {
                    // console.log(e.target.value, 'changed date');
                    setEndTimestamp(e.target.value);
                  }}
                  className='text-white'
                />
              </div>
              <div className="mb-2 bg-white">
                <TextField
                  fullWidth
                  variant="filled"
                  id="ticket"
                  label="Ticket Supply"
                  type="text"
                  value={ticketSupply}
                  onChange={(e) => {
                    if (Number.isInteger(Number(e.target.value))) {
                      setTicketSupply(e.target.value);
                    }
                  }}
                />
              </div>
              <div className="mb-2 bg-white">
                <TextField
                  fullWidth
                  variant="filled"
                  id="price"
                  label="Ticket Price"
                  type="text"
                  value={ticketPrice}
                  onChange={(e) => {
                    if (checkNumber(e.target.value)) {
                      setTicketPrice(e.target.value);
                    }
                  }}
                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                />
              </div>
              <div className="mb-2 bg-white">
                <FormControl className="w-full" variant="filled">
                  <InputLabel id="demo-simple-select-label">Token</InputLabel>
                  <Select
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={token}
                    onChange={handleChange}
                  >
                    {Array.from(tokenInfoMap.values())
                      .filter((t) => t.symbol)
                      .map((item: any) => (
                        <MenuItem
                          value={item.symbol}
                          key={item.symbol + Math.random()}
                        >
                          {item.symbol}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
              <div className="my-6">
                <div className=" flex items-center justify-center">
                  {publicKey ? (
                    <button
                      onClick={(e) => handleRaffle(e)}
                      className="GTWalsheimProBold bg-white mb-2 text-lg rounded text-brand_smooth_gray tracking-wider uppercase px-6 py-2"
                    >
                      Create Raffle
                    </button>
                  ) : (
                    <button
                      onClick={(e) => handleRaffle(e)}
                      className="cursor-not-allowed bg-white text-xl text-white tracking-wider uppercase px-6 py-2"
                    >
                      Connect Wallet
                    </button>
                  )}
                </div>
                {/* {tagHolder && (
                <p className="text-white text-center bg-brand_primary px-3 py-1 my-2">
                  Congratulations! You are eligible for fee discount for holding{' '}
                  {tagHolder}.
                </p>
              )} */}

               
              </div>
            </div>
          </div>
        ) : (
          <div className="GTWalsheimProBold text-center text-white py-16">
            ONLY ADMINS ARE ALLOWED TO CREATE RAFFLES
          </div>
        )}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="Choose NFT"
          aria-describedby="Show all NFT"
        >
          <div className="h-screen p-6 md:px-16 bg-brand_smooth_gray  bg-opacity-50">
            <div className=" text-white bg-brand_primary relative rounded-lg  flex items-center justify-center">
              <div className="absolute top-5 cursor-pointer rounded-full right-5 bg-brand_smooth_gray text-white text-3xl p-3">
                <ImCross onClick={() => handleClose()} />
              </div>
              <div>
                <h1
                  className={
                    'GTWalsheimProBold text-center primary_font uppercase w-full text-brand_secondary px-12 py-2'
                  }
                >
                  Choose NFT
                </h1>
                {!isLoading && !error && !nfts && (
                  <div className="md:text-xl pt-6">Loading Your NFTs</div>
                )}
                {!isLoading && !error && nfts.length ? (
                  <div className="flex flex-wrap justify-center space-x-2 space-y-2 items-center w-full hide-scrollbar overflow-y-scroll h-80vh">
                    {finalNFTs &&
                      finalNFTs.map((item) => (
                        <div
                          onClick={() => {
                            //@ts-ignore
                            setRaffleNFT(item);
                            handleClose();
                          }}
                          key={item.mint}
                          className="overflow-hidden hide-scrollbar bg-brand_smooth_gray w-full md:w-3/12 cursor-pointer img-hover"
                        >
                          {item?.data?.metadata?.image && (
                            <div className="">
                              <img
                                className=""
                                src={item.data.metadata.image}
                                alt={item.data.metadata.name}
                              />
                              {/* {console.log(item.data)} */}
                              <p className="GTWalsheimProBold p-2 text-sm text-center tracking-wider text-brand_secondary">
                                {item.data.name || ''}
                              </p>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="GTWalsheimProBold md:text-xl pt-6 text-center">
                    No NFTs Available
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Screen>
  );
}

export default CreateRaffle;
